import { useMutation } from "@tanstack/react-query";
import { uploadFile } from "./uploads.service";

export const useUploadFileMutation = () => {
  return useMutation({
    mutationFn: (file) => uploadFile(file),
  });
};
